import React from "react";
import PropTypes from "prop-types";
import PitchSlide from "./pitch_slide";
import MessageContent from "./message_content";

function SendMessage(props) {
  const { message } = props;

  return (
    <React.Fragment>
      { message.pitch && (
        <div className='overflowreset'>
          <PitchSlide pitch={message.pitch} />
        </div>
      )}
      <div className='outgoing-msg message-unit'>
        <div className='sent-msg'>
          <MessageContent
            content={message.content}
            created_at={message.created_at}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

SendMessage.propTypes = {
  message: PropTypes.shape({
    content: PropTypes.string.isRequired,
    created_at: PropTypes.string.isRequired,
    pitch: PropTypes.object
  }).isRequired
};

export default SendMessage;
